import React from 'react';
import './About.css'

const About = () => {
    return (
        <div className="about">
            <h1 className="name">About</h1> <br />
            <h2>Students at Global Academy develop the hands-on skills needed to work in the Broadcast and Digital Media Industry in our state-of-the-art surroundings</h2>
            <h3>Welcome to Global Academy. A unique school for Year 10 – Year 13 students specialising in the fast-paced and exciting creative media industry.
                We believe it’s crucial to arm students from all backgrounds with the proper technical, business and creative skills they need to work in the industry, and to help them connect their core studies with vocational skills in a truly practical and entrepreneurial way in an inspirational environment.
                If you love media – then why not join us and apply today?</h3>
        </div>
    );
};

export default About;